import { render, staticRenderFns } from "./UserConfigInfos.vue?vue&type=template&id=f2372662&"
import script from "./UserConfigInfos.vue?vue&type=script&lang=js&"
export * from "./UserConfigInfos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports